import { memo } from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

interface MediaDurationProps {
  duration: string;
  className?: string;
  iconClassName?: string;
}

const CLOCK_STROKE = '#135959';

const MediaDuration = memo(({ duration, className = '', iconClassName = 'h-4 w-4 shrink-0' }: MediaDurationProps) => (
  <span className={`flex items-center gap-1.5 font-haffer text-sh-12-18 text-people-gray-400 ${className}`.trim()}>
    <ClockIcon className={iconClassName} stroke={CLOCK_STROKE} strokeWidth={2} />
    {duration}
  </span>
));

MediaDuration.displayName = 'MediaDuration';

export default MediaDuration;
